import {HIDE_ERROR_EVENT, HIDE_SNACKBAR_EVENT, NOTIFY_ERROR_EVENT, NOTIFY_SNACKBAR_EVENT} from "./notifyActionTypes";

const initialState = {
    snackbar: '',
    error: '',
};

export default function notify(state = initialState, action) {
    switch (action.type) {
        case NOTIFY_SNACKBAR_EVENT: {
            const {payload} = action;
            return {
                ...state,
                snackbar: payload
            }
        }
        case NOTIFY_ERROR_EVENT: {
            const {payload} = action;
            return {
                ...state,
                error: payload
            };
        }
        case HIDE_ERROR_EVENT: {
            return {
                ...state,
                error: undefined
            };
        }
        case HIDE_SNACKBAR_EVENT: {
            return {
                ...state,
                snackbar: undefined
            };
        }
        default:
            return state;
    }
}
